import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from '@/components/ui';
import { PRIVACY_CONTACT_EMAIL } from '@library/constants/legal';

// One source for the address, shared with the app and the legal documents. It
// was hardcoded here as info@cwebspace.com while the documents said something
// else — see the note on PRIVACY_CONTACT_EMAIL for why that matters.
const CONTACT_EMAIL = PRIVACY_CONTACT_EMAIL;

// A mailto, not a contact form. A form would need an API endpoint, spam handling
// and somewhere to put what it collects — all of which is real work for something
// an email link already does.
export const Contact: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Section id="contact">
            <div className="contact">
                <div>
                    <h2 className="section__title" style={{ fontSize: 24 }}>{t('web.contact.title')}</h2>
                    <p className="section__sub">{t('web.contact.sub')}</p>
                </div>
                <a className="btn btn--lg" href={`mailto:${CONTACT_EMAIL}`}>
                    {t('web.contact.cta')}
                </a>
            </div>
        </Section>
    );
};
